class ShareButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.status = this.querySelector('[data-share-status]');
    this.button?.addEventListener('click', () => this.share());
  }
  async share() {
    const data = { title: this.dataset.title, url: this.dataset.url };
    if (navigator.share) {
      try {
        await navigator.share(data);
      } catch (error) {
        /* user cancelled */
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(data.url);
      this.status.textContent = this.dataset.copied || 'Link copied';
      setTimeout(() => (this.status.textContent = ''), 2500);
    } catch (error) {
      window.prompt('Copy link', data.url);
    }
  }
}
if (!customElements.get('share-button')) customElements.define('share-button', ShareButton);
